// Used not in all places.
// Please reuse it where possible

export const GROUP_SYNTAX = Object.freeze({
  OPEN: '(',
  CLOSE: ')',
  OPTIONAL_OPEN: '[',
  OPTIONAL_CLOSE: ']'
})
export const OR_SYNTAX = '|'
// List of pattern syntax that will be shown as "strong" tag
export const PATTERNS_STRONG_SYNTAX = Object.freeze([
  GROUP_SYNTAX.OPEN,
  GROUP_SYNTAX.CLOSE,
  GROUP_SYNTAX.OPTIONAL_OPEN,
  GROUP_SYNTAX.OPTIONAL_CLOSE,
  OR_SYNTAX
])
